module.exports = __webpack_public_path__ + "static/media/18.2120ba4a.jpg";